import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { usePlatform } from './usePlatform'
import { shortcutText } from '../lib/platform/shortcutText'

/**
 * `shortcutText` mit Plattform und Sprache der App — für Kürzel als reinen Text.
 *
 * @example
 * const shortcut = useShortcutText()
 * <ContextMenuShortcut>{shortcut('⌘W')}</ContextMenuShortcut> // Mac ⌘W, Windows (de) Strg+W
 */
export function useShortcutText(): (mac: string) => string {
  const { isMac } = usePlatform()
  const { i18n } = useTranslation()
  const language = i18n?.language ?? 'en'
  return useCallback((mac: string) => shortcutText(mac, { isMac, language }), [isMac, language])
}
